import { createCollectionReducer } from 'reducers/account/collections';
import { selectIsSynced } from 'reducers/account/requests';

export const TYPE = 'published-rules';

export default createCollectionReducer(TYPE);

export const selectPublishedRules = state => state.account.publishedRules;
export const selectArePublishedRulesSynced = state =>
  selectIsSynced(state, TYPE);
